export default "__VITE_ASSET__B72Myuft__"